export default {"src":"/statics/ecommerce/_next/static/media/big-discount-white.8df9e8a8.svg","height":16,"width":38,"blurWidth":0,"blurHeight":0};